<template>
  <v-flex row wrap xs12 sm12 md12 lg12 ml-2 mr-2>



    <v-flex :class="[$vuetify.breakpoint.smAndDown?'':'pr-3 pl-3','xs12 sm12 md8 lg8 ml-0 mt-1']"  >

      <v-flex  xs12 sm12 md12 fontMiddle regTitle row--dense style="text-align: center">

        {{zoneNameTitle}} {{formatRocDate(this.$route.query.viewDate)}}
        {{transApn(this.$route.query.apn)}}
        {{this.$route.query.divName}} {{this.$route.query.clinicName}} {{this.$route.query.doctorName}}
        <!--四季台安 掛號 初複診畫面-->
        <!--{{regInfo}}-->
      </v-flex>

      <!--<v-btn-toggle  class="mt-2 text-left" light v-model="toggleFV" mandatory   dense-->
      <!--rounded> &lt;!&ndash;@change="toggleStatusChange"&ndash;&gt;-->
      <!--<v-btn  value="second">-->
      <!--複診-->
      <!--&lt;!&ndash;<v-icon>assignment</v-icon>&ndash;&gt;-->
      <!--</v-btn>-->
      <!--<v-btn  value="first">-->
      <!--初診-->
      <!--&lt;!&ndash;<v-icon>timeline</v-icon>&ndash;&gt;-->
      <!--</v-btn>-->
      <!--</v-btn-toggle>-->

      <v-flex mt-2 :style="{textAlign:$vuetify.breakpoint.smAndDown?'center':'right'}" >

        <!--<v-btn @click="clearAll()"  middle class="pl-1 pr-1 mr-2 regFRBtn" :disabled="checkAgree==false">-->
        <!--取消輸入-->
        <!--</v-btn>-->
        <v-btn @click="addRegClick" v-show="addRegFlag=='ON'" middle class="pr-1 pl-1 regFRBtn" :disabled="addRegFlag=='OFF'&&lessRegDate==true&&isAddReg==true">
          加掛申請單
        </v-btn>
      </v-flex>


      <!-- 請勾選，如同意 -->
      <personal-permission :disabled="!firstCheck" :zone-name="zoneName" @agree="agree"></personal-permission>
      <v-container  style="padding: 0px">
        目前預計預約看診號碼為      <span class="nowViewNo">{{regInfo.viewNo==undefined?0:regInfo.viewNo}} </span> <span style="color: red;font-size: 1rem;font-weight: bold">如確認掛號，請點選初(複)診掛號...</span>
      </v-container>
      <v-flex v-html="errorContent"></v-flex>
      <v-flex style="font-size: 1.2rem;color: blue;font-weight: bold" v-html="clinicNoteA"></v-flex>





      <!--複診  v-if="toggleFV=='second'"-->
      <v-container style="padding: 0px">
        <v-row class="row--dense">
          <v-col cols="12" sm="12" md="12">
            <span class="regBodyFont">1.複診</span>
          </v-col>

          <v-col cols="12" sm="12" md="5" lg="5" class="d-inline-flex">
            <span  class="regLabel">身分證號/居留證*</span>
            <!--:value="idNo2 | hideIdNoMiddle"-->
            <!--@input="value => idNo2 = value"-->

            <div>
              <!--<v-text-field hide-details label="身分證號" clearable solo  ref="idNoTest" :value="idNo2|hideIdNoMiddle" @input="value=>idNo2=value"></v-text-field>-->
              <!--
                @keyup="inputChange"
                @input="value => idNo2 = changeValue(value)"
              -->
              <v-text-field
                  @keyup="valueToUpperCase('idNo2')"
                  @keypress="clsAlphaNoOnly"
                  maxlength="10"
                  :rules="[rules.required,rules.idNo1]"
                  @keyup.enter="NextItem('birthDate2')"
                  ref="idNo2"
                  v-model="idNo2"
                  :disabled="!firstCheck"
                  style="display: inline-block"
                  label="身分證號/居留證"
                  clearable
                  solo
              ></v-text-field>
            </div>


          </v-col>


          <v-col cols="12" sm="12" md="5" lg="5" style="text-align: right" class="d-inline-flex">
            <span  class="regLabel ">民_國生日*</span>
            <v-text-field
                pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==7) return false;"
                :rules="[rules.required,rules.birthCounter,rules.birthFormat]"
                ref="birthDate2"
                v-model="birthDate2"
                @blur="formatBirthDate('birthDate2')"
                :disabled="!firstCheck"
                style="display: inline-block"
                class="regInput hideNum"
                label="例0950101"
                clearable
                type="number"
                hint="例0950101"
                :hide-details="$vuetify.breakpoint.smAndDown"
                solo
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="2" lg="2" :class="[$vuetify.breakpoint.smAndDown?'text-right':'text-left']">
            <v-btn @click="checkPatient(idNo2,birthDate2,'R')"   middle class="ml-2 regFRBtn" :disabled="checkAgree==false||checkLoading==true" :loading="checkLoading">
              複診掛號
            </v-btn>
          </v-col>


        </v-row>
      </v-container>




      <v-divider></v-divider>


      <!--初診  v-if="toggleFV=='first'" -->
      <v-container v-show="allowFirstView==''||allowFirstView=='ON'" style="padding: 0px">
        <v-row class="row--dense">
          <v-col cols="12" sm="12" md="12" lg="12">
            <span class="regBodyFont">2.初診</span>

          </v-col>

          <!--<v-col cols="12" sm="12" md="8" style="text-align: right">-->

          <v-col cols="12" sm="12" md="6" lg="5" style="text-align: right" class="d-inline-flex">
            <span class="regLabel ">姓名*</span>
            <v-text-field
                :rules="[rules.required]"
                @keyup.enter="NextItem('birthDate')"
                ref="ptName"
                v-model="ptName"
                :disabled="!firstCheck"
                style="display: inline-block;"
                class="regInput"
                label="姓名"
                clearable
                solo
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="5" style="text-align: right" class="d-inline-flex">
            <span  class="regLabel ">民_國生日*</span>
            <v-text-field
                pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==7) return false;"
                :rules="[rules.required,rules.birthCounter,rules.birthFormat]"
                @keyup.enter="NextItem('idNo')"
                ref="birthDate"
                v-model="birthDate"
                @blur="formatBirthDate('birthDate')"
                :disabled="!firstCheck"
                style="display: inline-block;"
                class="regInput hideNum"
                label="例0950101"
                clearable
                type="number"
                hint="例0950101"
                solo
                :hide-details="$vuetify.breakpoint.smAndDown"
            ></v-text-field>
          </v-col>


          <v-col cols="12" sm="12" md="5" lg="5" class="d-inline-flex">
            <span  class="regLabel">身分證號/居留證*</span>
            <v-text-field
                @keyup="valueToUpperCase('idNo')"
                @keypress="clsAlphaNoOnly"
                maxlength="10"
                :rules="[rules.required,rules.idNo1]"
                @keyup.enter="NextItem('telNo')"
                ref="idNo"
                :disabled="!firstCheck"
                v-model="idNo"
                style="display: inline-block;"
                class="regInput"
                label="身分證號/居留證"
                clearable
                solo
            ></v-text-field>
          </v-col>



          <!--<v-col cols="12" sm="12" md="3" lg="0" class="d-inline-flex">-->
          <!--div-->
          <!--</v-col>-->


          <v-col cols="12" sm="12" md="5" lg="5" style="text-align: right" class="d-inline-flex">
            <span  class="regLabel ">電話*</span>
            <v-text-field
                pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==15) return false;"
                :rules="[rules.required]"
                type="number"
                ref="telNo"
                v-model="telNo"
                :disabled="!firstCheck"
                style="display: inline-block;"
                class="regInput hideNum"
                label="電話"
                clearable
                solo
            ></v-text-field>
          </v-col>



          <v-col cols="12" sm="12" md="2" lg="2" :class="[$vuetify.breakpoint.smAndDown?'text-right':'text-left']">
            <v-btn @click="checkPatient(idNo,birthDate,'F')"  middle class="ml-2 regFRBtn" :disabled="checkAgree==false||checkLoading==true" :loading="checkLoading">
              初診掛號
            </v-btn>
          </v-col>

          <!--</v-col>-->

          <!--<v-col cols="12" sm="12" md="4">-->

          <!--</v-col>-->






        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-flex style="font-size: 1.2rem">
        最近更新時間:{{updateTime}}
      </v-flex>






    </v-flex>

    <v-flex class="xs12 sm12 md4 lg4 pl-1 mt-1">

      <p v-html="regNote"></p>
    </v-flex>



    <v-dialog v-model="errorDialog"
              persistent
              :width="editDialogWidth+'%'"
              xs6 sm6 md6
              value="false"
              scrollable>
      <alert-win @closeDialog="closeErrorDialog" @confirm="errConfirm" :alery-type="aleryType"  :alert-title="errorTitle" :alert-msg="errorContent" ></alert-win>
    </v-dialog>

    <v-dialog
        v-model="checkLoading"
        hide-overlay
        persistent
        width="300"
    >
      <v-card
          color="toolbar"
          dark
      >
        <v-card-text>
          {{checkLoadingText}}
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addRegDialog"
              persistent
              :fullscreen="$vuetify.breakpoint.smAndDown"
              :width="editDialogWidth+'%'"
              xs6 sm6 md6
              value="false"
              scrollable>
      <add-reg @closeDialog="closeAddRegDialog" @save="saveAddReg"></add-reg>
    </v-dialog>





    <!-- 我是 snackbar -->
    <v-snackbar
        :timeout="snTimeout"
        v-model="snStatus">
      {{snText}}
    </v-snackbar>

  </v-flex>
</template>

<script>
import PersonalPermission from './PersonalPermission'
import AlertWin from '../inursingsys/AlertWin'
import AddReg from './AddReg'
export default {
  name: "RegTan",
  components:{PersonalPermission,AlertWin,AddReg},
  filters: {
    // IdNoFilter(val) {
    //     const reg = /^(.{3}).*(.{4})$/
    //     return val.replace(reg, '$1****$2')
    // },
    hideIdNoMiddle(val) {
      console.log('hideIdNoMiddle',val)
      if(val!==undefined&&val!==null){
        if(val.length>4){
          return `${val.substring(0,3)}****${val.substring(val.length-3)}`
        }
      }
    }
  },
  data() {
    return {
      regAtt:'',//診間注意事項
      clinicNoteA:'',
      zoneNameTitle:'',
      rules:{
        required: value => !!value || '必填.',
        birthCounter:value => value!=null && value!=='' && value!==undefined && value.length <= 7 || '最多7個數字',
        idNo1:v => /^[A-Z]{1}[A-Z1-9]{1}[0-9]{8}$/.test(v) || '身分證號格式錯誤',
        birthFormat: v => /^[0-1]?\d{1,2}[0-1]\d[0-3]\d$/.test(v) || '生日格式錯誤'
      },
      isAddReg:false,
      lessRegDate:false,
      addRegDialog:false,
      addRegFlag:'OFF',
      addRegFlagDoc:'',
      addRegObj:{},
      toggleFV:'second',
      snTimeout:4000,
      snStatus:false,
      snText:'',
      regInfo:{},
      zoneName:'',
      checkAgree:false,
      regNote:'',
      firstCheck:false,
      errorDialog:false,
      errorTitle: '',
      errorContent:'',
      aleryType:'error',
      checkLoading:false,
      checkLoadingText:'查詢中，請稍後',
      idNo2:'',//身分證號(複診)
      birthDate2:'',//民國生日(複診)
      idNo:'',//身分證號(初診)
      ptName:'',//患者姓名(初診)
      telNo:'',//電話(初診)
      birthDate:'',//民國生日(初診)
      regObject:{},
      updateTime:'',
      allowFirstView:'',//是否允許初診掛號 110/01/27 新增
    }
  },
  created(){
    this.axios_getAddRegSetting();
    this.axios_getSysAllowFirstView();//1100127 是否允許初診掛號
    this.axios_getZoneName();
    this.axios_getClinicNoteA(this.$route.query.zone,this.$route.query.viewDate,this.$route.query.apn,this.$route.query.clinicNo);

  },
  mounted: function() {
    if (this.$route.query.viewDate){
      let viewDate = this.$route.query.viewDate;
      let apn = this.$route.query.apn;
      let doctorNo = this.$route.query.doctorNo;
      let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
      let clinicNo = this.$route.query.clinicNo;
      this.axios_getRegClinic(viewDate,apn,doctorNo,zone,clinicNo);
      this.axios_getRegNote(this.$route.query.divNo+","+this.$route.query.clinicNo+","+this.$route.query.doctorNo)
      let today  =  this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString().toString(),'date').replace(new RegExp("-", 'g'), "")
      this.lessRegDate =(this.$UtilityJs.transROC2YMD(viewDate))<=today
    }
  },
  computed:{
    editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
      let width = 50;
      if (this.$vuetify.breakpoint.xs == true) {return width = 100}
      if(this.$vuetify.breakpoint.sm == true){return width = 97}
      if(this.$vuetify.breakpoint.md == true){return width = 68}
      if(this.$vuetify.breakpoint.lg == true){return width = 55}
      if(this.$vuetify.breakpoint.xl ==true){return width = 45}
      return width;
    },
  },
  methods:{
    formatBirthDate(refId){
      // 確保值為數字且長度為 6
      if(refId == 'birthDate'){
        if (this.birthDate.length === 6 && /^\d{6}$/.test(this.birthDate)) {
          this.birthDate = "0" + this.birthDate; // 自動補 0
        }
      }else {
        if (this.birthDate2.length === 6 && /^\d{6}$/.test(this.birthDate2)) {
          this.birthDate2 = "0" + this.birthDate2; // 自動補 0
        }
      }
    },
    valueToUpperCase(refId){ //自動將英文字母轉大寫 1101227 by IvyLin
      if(refId =='idNo'){
        if(this.idNo!=null&&this.idNo.length>0){
          this.idNo =  this.idNo.toUpperCase();
        }
      }else {
        if(this.idNo2!=null&&this.idNo2.length>0){
          this.idNo2 =  this.idNo2.toUpperCase();
        }
      }

    },
    clsAlphaNoOnly (e) {  // Accept only alpha numerics, no special characters //只允許輸入數字和文字 身分證號
      var regex = new RegExp("^[A-Za-z0-9 ]+$");
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      // console.log(str)
      if (regex.test(str)) {
        return true;
      }

      e.preventDefault();
      return false;
    },
    changeValue(val){
      console.log(val)
      if(val!==undefined&&val!==null){
        if(val.length>4){
          return `${val.substring(0,3)}****${val.substring(val.length-3)}`
        }
      }
    },
    inputChange:function (event) {
      console.log("inputChange=")
      let val = event.target.value;
      console.log(event.srcElement.id)
      console.log(val)
      // try{
      //     this.inputLimit(event,val);
      // }catch (e) {
      //     console.log(e.toString());
      // }
    },
    inputLimit:function(event,val){
      if((val.toString()).length>=4){
        console.log(val)
        // document.getElementById(event.srcElement.id).value=""
        // console.log("idNo2=",this.idNo2)
      }
    },
    maskID(){
      var IDlength = document.mform.custidMask.value.length;
      var custid = document.mform.custidMask.value;
      var strStar = "*****";


      if(IDlength == 10 || IDlength == 11){
        document.mform.custid.value = document.mform.custidMask.value.trim();
        document.mform.custidMask.value = custid.substr(0,4) + strStar + custid.substr(9,custid.length);
      } else {
        document.mform.custid.value = document.mform.custidMask.value.trim();
      }
    },
    splitURL(name,url){
      return  decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(this.$store.state.AppSetting.backSrvUrl+"?"+url)||[""])[1].replace(/\+/g,'%20'))||null;
    },
    clearAll(){
      this.idNo = "";
      this.birthDate = "";
      this.ptName = "";
      this.telNo = "";
      this.idNo2 = "";
      this.birthDate2 = "";
    },
    NextItem(nextId){
      this.$refs[nextId].focus();
    },
    checkPatient(idNo,birthDate,fvRv){
      this.axios_getCheckPatient(this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone,idNo,birthDate,fvRv)
    },
    closeErrorDialog(){
      this.errorDialog = false;
    },
    //加掛申請單
    addRegClick(){
      if((this.addRegFlag=='ON')&&(this.errorContent.indexOf('額滿')>-1)){
        this.addRegDialog = true;
        this.addRegObj = {
          idNo: "",
          birthDate: "",
          appDate: this.$route.query.viewDate,
          ptName: "",
          doctorNo: this.$route.query.doctorNo,
          divNo: this.$route.query.divNo,
          apn: this.$route.query.apn,
          contact: "",
          note01Flag: "N",
          note02Flag: "N",
          note03Flag: "N",
          noteOtherFlag: "N",
          noteOther: "",
          clinicNo: this.$route.query.clinicNo
        }
      }else {
        alert('無法加掛申請');
      }
    },
    closeAddRegDialog(){
      this.addRegDialog = false;
    },
    saveAddReg(item){
      this.axios_postRegAddNote(item)
    },
    errConfirm(){
      this.closeErrorDialog();
    },
    agree(agree){
      this.checkAgree = agree;
    },
    transApn(apn){
      if(apn.toString()=="1"){
        return "早上";
      }else if(apn.toString()=='2') {
        return "下午";
      }else {
        return "晚上";
      }
    },
    formatRocDate(viewDate){
      let yyy = viewDate.substring(0,3);
      let mm = viewDate.substring(3,5);
      let dd = viewDate.substring(5,7);
      return yyy+"年"+mm+"月"+dd+"日";
    },
    axios_getRegClinic(viewDate,apn,doctorNo,zone,clinicNo){ //查詢掛號 第一階段檢查
      this.checkLoading = true
      this.errorContent = '';
      this.firstCheck = false;
      this.regNote = '';
      let url = this.$store.state.AppSetting.backSrvUrl+'webregistration/precheck/'+viewDate+"/"+apn+"/"+doctorNo+"/"+zone+"/"+clinicNo;


      this.$http.get(url).then(response=>{
        this.snStatus=true;
        this.snText = response.data.message;
        if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
          this.updateTime = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'all');
          this.regInfo = response.data.resultSet[0];
          this.zoneName = this.regInfo.zoneName;
          this.firstCheck = true;
          this.checkLoading = false;
          this.isAddReg = parseInt(this.regInfo.viewNo)>0;
          if(this.isAddReg==true){
            this.lessRegDate = true;
            this.addRegFlag='OFF'
          }else {
            let today  =  this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString().toString(),'date').replace(new RegExp("-", 'g'), "")
            this.lessRegDate =(this.$UtilityJs.transROC2YMD(viewDate))<=today
            if(this.lessRegDate==true){
              this.isAddReg=true;
              this.addRegFlag='OFF'
            }
          }
          // console.log(this.addRegFlag=='OFF')
          // console.log(this.lessRegDate)
          // console.log(this.isAddReg)

        }else {
          this.updateTime = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'all');
          this.checkLoading = false;
          this.zoneName = '';
          this.firstCheck = false;
          this.errorDialog = true;
          this.errorTitle = response.data.status;
          this.errorContent = '<div style="color: #BE002F">'+ response.data.message+'</div>';
        }
        this.snText = response.data.message;
      }).catch(error =>{
        this.zoneName = '';
        this.firstCheck = false;
        this.checkLoading = false;
        try {
          switch (error.response.status){
            case 300:
            case 400:
            case 401:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+ error.response.data.message+'</div>';
              break;
            case 404:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ="找不到頁面";
              break;
            case 500:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = "伺服器錯誤";
              break;
            default:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ='<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
          }

          if(this.errorContent.indexOf('額滿')>-1&this.addRegFlag=='ON'){
            this.addRegFlag = 'ON'
          }else {
            this.addRegFlag = 'OFF'
            this.isAddReg=true;
            this.lessRegDate = true;
          }



        } catch(err) {
          console.log(err.response.data.message)
        }
      });
    },
    axios_getRegNote (codeNo){ //掛號說明
      let url = '';
      let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
      url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/REG/"+codeNo;

      this.$http.get(url).then(response =>{
        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
          for(let i in response.data.resultSet){
            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
              this.regNote+=response.data.resultSet[i].regNote+"<br/>"
            }
          }
        }else{
          this.regNote = '';
        }


      }).catch(error =>  {
        try {
          console.log(error.response.data.status);
          this.regNote = '';
        } catch(err) {
          this.regNote = '';
        }
      });
    },
    // http://172.16.1.72:8080/iRegaSrv/rest/webregistration/checkpatient/{zone}/{idOrChartNo}/{birthDate}
    axios_getCheckPatient(zone,idOrChartNo,birthDate,fvRv){ //第二階段檢查 確認患者為初診還複診 身分證號 尚未修改
      this.errorContent = "";//清空錯誤訊息
      this.checkLoading = true;
      if(idOrChartNo==''||idOrChartNo==null||idOrChartNo==undefined||birthDate==''||birthDate==null||birthDate==undefined){
        alert('請輸入身分證號 和 民_國生日')
        this.checkLoading = false;
        return;
      }
      let today  =  this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString().toString(),'date').replace(new RegExp("-", 'g'), "")
      let yyy = today.substring(0,4);
      let mm = today.substring(4,6);
      let dd = today.substring(6,8)
      if(birthDate>(yyy-1911)+""+mm+""+dd){
        let errorMsg = '<div style="font-weight: bold;font-size: 1.5rem">'+(birthDate)+'</div> 出生日期不合法，請確認是否輸入正確。'
        this.errorDialog = true;
        this.errorTitle = "訊息";
        this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+ errorMsg+'</div>';
        this.checkLoading = false;
        return;
      }

      let url = this.$store.state.AppSetting.backSrvUrl+'webregistration/checkpatient/'+zone+"/"+idOrChartNo+"/"+birthDate;
      // 初複診: regClerk {WEBREG, APPREG} 請依據相應掛號平台填入
      // let regClerk = this.$store.state.AppSetting.regClerk=='WEBREG'?this.$store.state.AppSetting.WEBREG:this.$store.state.AppSetting.APPREG; // 110/07/15修改 需等後端修改完成 方能套用
      let regClerk = this.$store.state.AppSetting.regClerk; // 110/07/29修改 直接把參數改成webKey 存在專案設定檔中
      this.$http.get(url).then(response=>{
        this.snStatus=true;
        // this.snText = response.data.message;
        if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
          let data = response.data.resultSet[0];
          this.snText = data.rtnMessage;
          if(data.fvRv=="F"){ //如果是初診患者 需確認是否已輸入 患者姓名和電話

            if(this.allowFirstView=='OFF'){
              this.errorDialog = true;
              this.errorTitle = "不允許初診掛號";
              this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+ '初診患者 不允許初診掛號'+'</div>';
              this.checkLoading = false;
            }else {
              let ptName = this.ptName==undefined||this.ptName==""||this.ptName==null?'':this.ptName;
              let telNo = this.telNo==undefined||this.telNo==""||this.telNo==null?'':this.telNo;

              if(fvRv=='R'){ //如果點複診按鈕
                this.idNo = this.idNo2;
                this.birthDate = this.birthDate2;

                this.idNo2 = '';
                this.birthDate2 = '';
                this.checkLoading = false;
              }


              if(ptName==''||telNo==''){
                if(fvRv=='R'){ //如果點複診按鈕
                  alert('找不到患者病歷資料，是否確定為初診掛號? \n' +
                      '請輸入初診資料(姓名、民_國生日、身分證號、電話)後，\n按「初診掛號」按鈕');
                  this.checkLoading = false;
                }else {
                  alert('請輸入初診資料(姓名、民_國生日、身分證號、電話)後，\n按「初診掛號」按鈕');
                  this.checkLoading = false;
                }

                this.$refs.ptName.focus();
                this.errorContent = "";//清空錯誤訊息
                this.checkLoading = false;
              }else {
                let viewDate = this.$route.query.viewDate;
                let apn = parseInt(this.$route.query.apn);
                let doctorNo = this.$route.query.doctorNo;
                let doctorName = this.$route.query.doctorName;
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let clinicNo = parseInt(this.$route.query.clinicNo);
                let clinicName = this.$route.query.clinicName;
                let divNo = this.$route.query.divNo;
                let divName = this.$route.query.divName;
                let firstViewObj = {
                  viewDate: viewDate,
                  apn: apn,
                  doctorNo: doctorNo,
                  doctorName: doctorName,
                  zone:zone,
                  zoneName: this.zoneName,
                  clinicNo: clinicNo,
                  clinicName: clinicName,
                  divNo: divNo,
                  divName: divName,
                  idNo: idOrChartNo,
                  birthDate: birthDate,
                  ptName: ptName,
                  telNo: telNo,
                  // regClerk: this.$store.state.AppSetting.regClerk //此處須修改 改傳webKey 110/07/15
                  regClerk: regClerk // 改傳webKey 110/07/15
                }
                this.axios_postWebReg(firstViewObj,'F',fvRv);
                //call掛號 第三階段API
              }
            }

          }else { //複診患者 直接走第三階段
            if(fvRv=='F'){ //如果是複診患者 又點了初診按鈕則須提示 110/09/03 修改 By IvyLin
              this.errorDialog = true;
              this.errorTitle = data.rtnMessage;
              this.checkLoading = false;
              let errMsg = "經系統檢查 : "+data.ptName +" 您為複診病人，請以[複診掛號]進行掛號，謝謝!!"
              this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+errMsg +'</div>';

              //自動將身分證號&民國生日帶回複診掛號框
              this.idNo2 = this.idNo;
              this.birthDate2 = this.birthDate;
              return ;
            }
            let viewDate = this.$route.query.viewDate;
            let apn = parseInt(this.$route.query.apn);
            let doctorNo = this.$route.query.doctorNo;
            let doctorName = this.$route.query.doctorName;
            let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
            let clinicNo = parseInt(this.$route.query.clinicNo);
            let clinicName = this.$route.query.clinicName;
            let divNo = this.$route.query.divNo;
            let divName = this.$route.query.divName;
            let patOpdObj = {
              viewDate: viewDate,
              apn: apn,
              doctorNo: doctorNo,
              doctorName: doctorName,
              zone:zone,
              zoneName: this.zoneName,
              clinicNo: clinicNo,
              clinicName: clinicName,
              divNo: divNo,
              divName: divName,
              idNo: idOrChartNo,
              birthDate: birthDate,
              ptName: data.ptName,
              telNo: null,
              // regClerk: this.$store.state.AppSetting.regClerk //此處須修改 改傳webKey 110/07/15
              regClerk: regClerk // 改傳webKey 110/07/15
            }
            this.axios_postWebReg(patOpdObj,'R',fvRv);
          }

        }else {
          // this.firstCheck = false;
          this.errorDialog = true;
          this.errorTitle = "訊息";
          this.errorContent = '<div style="color: #BE002F">'+ response.data.message+'</div>';
          this.snText = response.data.message;
          this.checkLoading = false;
        }

      }).catch(error =>{
        this.checkLoading = false;
        // this.firstCheck = false;
        try {
          let errorMsg = error.response.data.message==undefined?error.response.data.status:error.response.data.message;
          switch (error.response.status){
            case 300:
            case 400:
            case 401:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+ errorMsg+'</div>';
              break;
            case 404:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ="找不到頁面";
              break;
            case 500:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = "伺服器錯誤";
              break;
            default:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ='<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
          }

        } catch(err) {
          console.log(err.response.data.message)
        }
      });
    },
    //第三階段 掛號
    axios_postWebReg(postData,fvRv,btnFvRv){ //新增 初診患者 複診患者
      this.checkLoading = true
      let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
      let url = this.$store.state.AppSetting.backSrvUrl+'webregistration/'+zone;

      this.$http.post(url,postData).then(response=>{
        if(response.data.resultSet.length>0&&response.data.status == 'INFO'){
          // this.snStatus=true;
          this.checkLoading = false;
          this.snText = response.data.message;
          this.snText+="你已掛號成功，看診號碼為:"+response.data.resultSet[0].viewNo;
          if(btnFvRv!==fvRv){
            this.snText = ('複診患者 掛號成功 \n看診號碼為:'+response.data.resultSet[0].viewNo)
          }else {
            let fvRvTxt = fvRv=='F'?'初診患者':'複診患者';
            this.snText = (fvRvTxt+' 掛號成功 \n看診號碼為:'+response.data.resultSet[0].viewNo)
          }
          this.errorContent = "";
          let chartNo = response.data.resultSet[0].chartNo==undefined||response.data.resultSet[0].chartNo==null?0:response.data.resultSet[0].chartNo;

          // const urlParams = new URLSearchParams(this.$store.state.AppSetting.backSrvUrl+'?'+url);
          // let divName = urlParams.get('divName');

          this.$router.push({name: 'RegSuccess',  params:{viewNo:response.data.resultSet[0].viewNo,
              chartNo:chartNo,ptName:response.data.resultSet[0].ptName,
              birthDate:response.data.resultSet[0].birthDate,idNo:response.data.resultSet[0].idNo,fvRv:fvRv},
            query: {viewDate:this.$UtilityJs.getUrlKey("viewDate",url),apn: this.$UtilityJs.getUrlKey("apn",url),
              doctorNo:this.$UtilityJs.getUrlKey("doctorNo",url),zone:this.$UtilityJs.getUrlKey("zone",url),clinicNo:this.$UtilityJs.getUrlKey("clinicNo",url),
              doctorName:this.$UtilityJs.getUrlKey("doctorName",url),clinicName:this.$UtilityJs.getUrlKey("clinicName",url),
              divNo:this.$UtilityJs.getUrlKey("divNo",url),divName:this.$route.query.divName,zoneName:response.data.resultSet[0].zoneName}});

        }else {
          this.snStatus=true;
          this.snText = response.data.message;
          this.errorDialog = true;
          this.errorTitle = "訊息";
          this.errorContent = response.data.message;
          this.checkLoading = false;
        }
      }).catch(error =>{
        try{
          this.snStatus=true;
          this.snText = error.response.data.message;
          this.checkLoading = false;
          let errorMsg = error.response.data.message==undefined?error.response.data.status:error.response.data.message;
          switch (error.response.status){
            case 300:
            case 400:
            case 401:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+ errorMsg+'</div>';
              break;
            case 404:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ="找不到頁面";
              break;
            case 500:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = "伺服器錯誤";
              break;
            default:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ='<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
          }
        }catch (e) {
          this.snStatus=true;
          this.snText = error.response.data.message;
        }
      });
    },
    // REGCOND	ADD_REG 加掛申請判斷 是否開啟
    axios_getAddRegSetting (){ //取得加掛申請條件 ON 或 OFF
      let url = '';
      url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/REGCOND/ADD_REG";

      this.$http.get(url).then(response =>{
        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
          this.addRegFlag = response.data.resultSet[0].value1;
          this.addRegFlagDoc = response.data.resultSet[0].value2==undefined||response.data.resultSet[0].value2==""?'':response.data.resultSet[0].value2;
          if(this.addRegFlagDoc!==''&&this.addRegFlag=='ON'){
            let docList = this.addRegFlagDoc.indexOf(this.$route.query.doctorNo)
            if(docList>-1){
              this.addRegFlag=='ON'
            }else {
              this.addRegFlag = 'OFF'
            }
          }else if(this.addRegFlag=='ON'&&this.addRegFlagDoc==''){
            this.addRegFlag = 'ON';
          }

        }else{
          this.addRegFlag = "OFF"
        }

      }).catch(error =>  {
        this.addRegFlag = "OFF"
        try {
          console.log(error.response.data.status);
        } catch(err) {
          console.log(err.response.data.status);
        }
      });


    },

    axios_postRegAddNote(postData){ //新增 加掛申請
      let postList = [];
      postList.push(postData);
      let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
      let url = '';
      url = this.$store.state.AppSetting.backSrvUrl + "regaddnote/"+zone;

      this.$http.post(url,postList).then(response=>{
        this.snStatus=true;
        this.snText = response.data.message;
        if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
          this.axios_getCheckAddReg(postData.idNo,postData.appDate,999)
        }
        this.snText = response.data.message;
      }).catch(error =>{
        try{
          let errorMsg = error.response.data.message==undefined?error.response.data.status:error.response.data.message;
          switch (error.response.status){
            case 300:
            case 400:
            case 401:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+ errorMsg+'</div>';
              break;
            case 404:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ="找不到頁面";
              break;
            case 500:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = "伺服器錯誤";
              break;
            default:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ='<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
          }
        }catch (e) {
          this.snStatus=true;
          this.snText = error.response.data.message;
        }
      });
    },
    axios_getCheckAddReg (idNo,viewDate,seqNo){ //查詢是否加掛成功
      let url = '';
      let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
      url = this.$store.state.AppSetting.backSrvUrl + "regaddnote/datasearch/primarykeys/"+zone+"/"+idNo+"/"+viewDate+"/"+seqNo;
      this.$http.get(url).then(response =>{
        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
          this.addRegDialog = false;
          this.snStatus = true;
          this.snText = response.data.message;
        }else{
          this.snStatus = true;
          this.snText = response.data.message;
        }

      }).catch(error =>  {
        try {
          switch (error.response.status){
            case 300:
            case 400:
            case 401:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = '<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+ error.response.data.message+'</div>';
              break;
            case 404:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ="找不到頁面";
              break;
            case 500:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent = "伺服器錯誤";
              break;
            default:
              this.errorDialog = true;
              this.errorTitle = "訊息";
              this.errorContent ='<div style="color: #BE002F;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
          }

        } catch(err) {
          console.log(err.toString())
        }

      });
    },
    axios_getSysAllowFirstView (){ //查詢 允許初診掛號  ALLOW_FIRSTVIEW 設定檔
      let url = '';
      this.allowFirstView = '';
      url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/REGCOND/ALLOW_FIRSTVIEW";

      this.$http.get(url).then(response =>{
        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
          this.allowFirstView = response.data.resultSet[0].value1;

        }else{
          this.allowFirstView = '';
        }


      }).catch(error =>  {
        try {
          console.log(error.response.data.status);
          this.allowFirstView = '';
        } catch(err) {
          this.allowFirstView = '';
        }

      });


    },
    axios_getZoneName (){  //查詢院區名稱
      this.zoneNameTitle = '';
      let url = '';
      let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
      url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/"+zone;
      this.$http.get(url).then(response =>{
        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
          this.zoneNameTitle = response.data.resultSet[0].zoneName;
        }else{
          this.zoneNameTitle ='';
        }
      }).catch(error =>  {
        this.zoneNameTitle = '';
        try {
          console.log(error.response.data.status);

        } catch(err) {
          console.log(err.toString())
        }
      });
    },
    axios_getClinicNoteA (zone,viewDate,apn,clinicNo) { //診間掛號提示訊息
      let url = '';
      this.clinicNoteA = '';
      url = this.$store.state.AppSetting.backSrvUrl + "clinicnote/datasearch/primarykeys/" + zone + "/" + viewDate + "/" + apn + "/" + clinicNo + "/A";

      this.$http.get(url).then(response => {
        if (response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length > 0) {
          this.clinicNoteA = response.data.resultSet[0].promptNote==null||response.data.resultSet[0].promptNote==''?'':response.data.resultSet[0].promptNote;
          this.axios_getRegNoteRegAtt(this.$route.query.clinicNo);
        } else {
          this.clinicNoteA = '';
          this.axios_getRegNoteRegAtt(this.$route.query.clinicNo);
        }


      }).catch(error => {
        try {
          console.log(error.response.data.status);
          this.clinicNoteA = '';
        } catch (err) {
          console.log(err)
          this.clinicNoteA = '';
        }
        this.axios_getRegNoteRegAtt(this.$route.query.clinicNo);


      });


    },
    axios_getRegNoteRegAtt (codeNo){ //診間注意事項 1101027 By IvyLin
      let url = '';
      this.regAtt = '';
      let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
      url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/REGATT/"+codeNo;

      this.$http.get(url).then(response =>{
        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
          for(let i in response.data.resultSet){
            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
              this.regAtt+=response.data.resultSet[i].regNote+"<br/>"
            }
          }

          this.clinicNoteA= this.clinicNoteA.length>0? this.clinicNoteA+','+this.regAtt:this.regAtt;
        }else{
          this.regAtt = '';
        }


      }).catch(error =>  {
        try {
          console.log(error.response.data.status);
          this.regAtt = '';
        } catch(err) {
          this.regAtt = '';
        }
      });
    },

  }
}
</script>

<style scoped>

.regTitle{
  background: #C8E3FF;
  color: #1D2088;
  font-weight: bold;
  border: 1px solid #BAA7AA;
  padding: 10px;
}

.regBodyFont{
  color: #23AAE9;
  font-size: 1.2rem;
}

.regInput{
  min-height: auto!important;
}

.regLabel{
  margin-top: 12px!important;
  margin-right: 5px;
  min-width: 130px;
  text-align: right;
}

.nowViewNo{
  color: #FF6666;
  font-weight: bold;
  font-size: 2rem;
}

.errorFont{
  color: #BE002F;
  font-size: 1.5rem;
  font-weight: bold;
}

.hideId{
  overflow: hidden;
  width: 1em;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.inlineBlack{
  display: inline-block;
  color: black;
}

.hideDiv{
  /*display: none;*/
}

</style>